/** Тексты окна: Серия дней: окно и карточка десктопа. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.streak.title": "Daily streak · Day {n}",
  "win.streak.day": "Day {n}",
  "win.streak.bigBag": "Big bag",
  "win.streak.claim": "Claim",
  "win.streak.claimed": "Come back tomorrow",
  "win.streak.note": "Miss a day and the streak starts over.",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.streak.title": "Серия · день {n}",
  "win.streak.day": "День {n}",
  "win.streak.bigBag": "Мешок",
  "win.streak.claim": "Забрать",
  "win.streak.claimed": "Приходи завтра",
  "win.streak.note": "Пропустишь день — серия начнётся заново.",
};

const uk: Record<Key, string> = {
  "win.streak.title": "Серія · день {n}",
  "win.streak.day": "День {n}",
  "win.streak.bigBag": "Мішок",
  "win.streak.claim": "Забрати",
  "win.streak.claimed": "Приходь завтра",
  "win.streak.note": "Пропустиш день, і серія почнеться спочатку.",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
